// extracted by mini-css-extract-plugin
export default {"file":"homeSlide_file__GhGOq","movement":"homeSlide_movement__nsdlC","title":"homeSlide_title__DYENu"};